import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';
import { EmailModel } from '../input/rules/implementations/email.model';

export default class ForgetPasswordModel {
    CpfOuEmail: string;

    cpfOuEmailInputModel = new InputModel(true, false, 'email', 'E-mail', [new RequiredModel(), new EmailModel()]);
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/forget-password/forget-password.model.ts